import React from 'react';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
import { Kicker, H2 } from './ui/Typography';
import { useT } from '../i18n/LanguageContext';
export function WhatsInsideSection() {
  const t = useT().whatsInside;
  return <Section hasOrb={true} data-id="element-224">
      <Kicker data-id="element-225">{t.kicker}</Kicker>
      <H2 data-id="element-226">
        {t.title1} <span className="text-brand" data-id="element-227">{t.title2}</span>
      </H2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-16" data-id="element-228">
        {t.cards.map((feat, i) => <Card key={i} delay={i * 0.1} data-id="element-229">
            <div className="font-mono text-brand text-sm mb-4" data-id="element-230">
              / {feat.num}
            </div>
            <h3 className="font-archivo text-xl uppercase tracking-tight mb-4" data-id="element-231">
              {feat.title}
            </h3>
            <p className="text-ink-dim text-sm leading-relaxed" data-id="element-232">{feat.desc}</p>
          </Card>)}
      </div>
    </Section>;
}